/**
 *
 * When defining a rule using a string, exact matching will be tested
 * Use regexp for more complex rules, which involve dynamic parts or partial testing.
 *
 */
export const ignoredErrors: Array<string | RegExp> = [
  // Third party scripts errors. Non actionable.
  /Script error/,
  // Network errors that are not actionable, and not a system error.
  'Network Error [null]',
  // Error caused by Crawling bot: https://trackjs.com/javascript-errors/object-not-found-matching-id-methodname-paramcount/
  /Object Not Found Matching Id:\d, MethodName:.+, ParamCount:\d/,
  // Google Maps lib error: https://stackoverflow.com/questions/39005292/google-map-zoom-event-ignored-attempt-to-cancel-a-touchend-event-with-cancelabl
  /Ignored attempt to cancel a touchmove event with cancelable=false, for example because scrolling is in progress and cannot be interrupted/,
  // Google Maps lib error : https://issuetracker.google.com/issues/361372989
  /this.Eg.close is not a function/,
  // Google Auth2 Popup window closed by the user
  'Popup window closed',
  // GoogleTap non actionable error (does not create disruption)
  /\[GSI_LOGGER\]: FedCM get\(\) rejects with/,
  // GoogleTap non actionable error (does not create disruption)
  /\[GSI_LOGGER\]: Failed to open popup window on url:/,
  // Most likely caused by bots:  https://arstechnica.com/information-technology/2019/03/a-new-rash-of-highly-covert-card-skimming-malware-infects-ecommerce-sites/
  /Can't find variable: gmo/,
  // Not actionable error
  /ResizeObserver loop completed with undelivered notifications/,
  // Not actionable error: Know issue in Next related to prefetching links. Not blocking navigation https://github.com/vercel/next.js/issues/53813
  /Load failed/,
  // we are sending a user.login.socials.error.facebook_api_connect_error action instead
  'Unable to connect with Facebook API',
]
